module.exports = __webpack_public_path__ + "img/logo2.678dc49e.jpg";